/**
 * Created by mykurisu on 2017/8/2.
 */
import React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import {ClickLoadMore} from '../../components'
import ListenerManageListItem from './ListenerManageListItem'

class ListenerManageListPassed extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ended: false,
            loading: false,
            has_more: this.props.listenermanage.listener_passed.has_more,
            next_offset: this.props.listenermanage.listener_passed.next_offset
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            has_more: nextProps.listenermanage.listener_passed.has_more,
            next_offset: nextProps.listenermanage.listener_passed.next_offset,
            ended: !nextProps.listenermanage.listener_passed.has_more
        });
    }

    handleLoadMore() {
        const {listenermanage} = this.props;
        this.setState({
            loading: true
        });
        axios.get(`/api/${listenermanage.url_data.type}/${listenermanage.url_data.id}/listener_list`, {
            params: {
                granted: 'passed',
                keyword: listenermanage.searchKeys,
                offset: this.state.next_offset
            }
        }).then((res) => {
            if (res.data.code === 0){
                this.setState({
                    has_more: res.data.data.has_more,
                    next_offset: res.data.data.next_offset,
                    loading: false
                });
                let list = listenermanage.listener_passed_list;
                for (let i = 0;i<res.data.data.listeners.length;i++){
                    res.data.data.listeners[i].checked = false;
                    res.data.data.listeners[i].type = 'passed';
                }
                list = list.concat(res.data.data.listeners);
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_PASSED_INIT',
                    payload: res.data.data
                });
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_PASSED_APPEND',
                    payload: list
                })
            }
        })
    }

    render() {
        const {listenermanage} = this.props;
        const {ended, loading, has_more} = this.state;
        const loadingstatus = {
            ended: ended,
            loading: loading,
            has_more: has_more,
            loadMethod: () => {
                this.handleLoadMore()
            }
        };


        return (
            <div className="listener-manage-tab">
                {listenermanage.url_data.type === 'lecture' &&
                <p className="text-minor weui-padding">
                    *授权听众列表显示允许进入课堂的用户，未授权则反之；
                    <br />
                    *免费课改为付费课后，用户需购买课程才能授权进入。
                </p>
                }

                {listenermanage.url_data.type === 'channel' &&
                <p className="text-minor weui-padding">
                    *授权听众列表显示允许浏览专栏所有课程的用户，未授权则反之；
                </p>
                }

                {listenermanage.listener_passed_list.map((item) => <ListenerManageListItem key={item.id}
                                                                                           content={item}/>)}

                <ClickLoadMore loadingstatus={loadingstatus} />
            </div>
        )
    }
}

export default connect(state => ({
    listenermanage: state.listenermanage
}))(ListenerManageListPassed)


// WEBPACK FOOTER //
// ./src/components/listenerManage/ListenerManageListPassed.js